/* eslint-disable no-console */
import Config from '@/config'

// XXX backward compat
import _locator from '@/service-locator'

import clientLogger from '@/plugins/logger/core'

import { isDebugging } from './live-debug'

const CONSOLE_METHOD_MAPS = {
  fatal: 'error',
  exception: 'error',
  error: 'error',
  warning: 'warn',
  info: 'info',
  debug: 'log',
  trace: 'log',
}

const LOG_LEVEL_GRADES = Object.keys(CONSOLE_METHOD_MAPS).reduce(
  (grades, key, idx) => ({
    ...grades,
    [key]: idx,
  }),
  {}
)

const compareLogLevels = (level, appLevel) =>
  LOG_LEVEL_GRADES[level] <= LOG_LEVEL_GRADES[appLevel]

const makeLoggerMethod =
  (console, level, consoleMethod) => (message, extra, tags) => {
    if (Config.isDev) {
      // log to default console, always
      console[consoleMethod](level, message, extra, tags)
    }

    const shouldNewRelicCaptureError =
      isDebugging() || compareLogLevels(level, LOG_LEVEL_GRADES.error)

    if (shouldNewRelicCaptureError) {
      clientLogger.noticeError(message, extra)
    }
  }

const getLogMethods = (console) =>
  Object.entries(CONSOLE_METHOD_MAPS).reduce(
    (methods, [level, consoleMethod]) => ({
      ...methods,
      [level]: makeLoggerMethod(console, level, consoleMethod),
    }),
    {}
  )

const makeOnError = (locator, originalOnError) =>
  function onError() {
    locator.logger.error.apply(null, arguments)
    originalOnError && originalOnError.apply(null, arguments)
  }

const buildRootLogger = (locator, console = window.console) => {
  const logMethods = getLogMethods(console)

  window.onerror = makeOnError(locator, window.onerror)

  const instance = {
    warn: logMethods.warning,
    ...logMethods,
  }

  locator.logger = instance
  return instance
}

export { buildRootLogger, CONSOLE_METHOD_MAPS }

// XXX backward compat, remove later on
export default _locator.logger
